import { ReducerBuilder } from 'typescript-fsa-reducers';

import { applyAsyncReducer } from '@utils';

import { authLogin } from './authLogin';

import { IAuthStore } from '../../types';
import { IActionAuthLoginPayloadDone } from './types';

export const authLoginReducer = (auth: ReducerBuilder<IAuthStore, IAuthStore>) => {
	applyAsyncReducer<IAuthStore['user']['data'], IAuthStore['user']['meta']>()(
		'user',
		'networkStatus',
		authLogin.async,
		auth,
		(props: { result: IActionAuthLoginPayloadDone }) => ({
			user: props.result.user,
		}),
	);
};
